<template>
  <v-container fluid class="pt-4">
    <v-layout wrap>
      <v-flex xs12>
        <h2 class="headline mt-0">{{ $t('Quota GPT') }}</h2>
      </v-flex>
      <v-flex xs12>
        <p>
          {{ $t('Quota') }}: {{ tokenQuotaUsed | numberFormat }} /
          {{ tokenQuotaLimit | numberFormat }}
        </p>
        <div style="border: 1px solid var(--primary-color); padding: 8px 16px; border-radius: 8px">
          <v-progress-linear v-model="percent" :height="24" rounded :loading="true">
            <strong style="color: #fff; display: flex; justify-content: center; align-items: center"
              >{{ percent | decimalFormat }}%</strong
            >
          </v-progress-linear>
        </div>
        <small>{{ $t('The system will update the messages sent within the day.') }}</small>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import gptApi from '@/api/gpt'
export default {
  data() {
    return {
      percent: 0,
      tokenQuotaLimit: 0,
      tokenQuotaUsed: 0
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    this.handleGetData()
  },
  methods: {
    async handleGetData() {
      try {
        this.$store.dispatch('loading')
        const response = await gptApi.getChatGPTQuota({
          pageId: this.selectedBot.pageid
        })
        const { status, data } = response
        if ([200].includes(status)) {
          const { token_quota_limit, token_quota_used, token_quota_additional } = data.data
          this.tokenQuotaLimit = token_quota_limit + token_quota_additional
          this.tokenQuotaUsed = token_quota_used
          this.percent = (token_quota_used / (token_quota_limit + token_quota_additional)) * 100
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.$store.dispatch('loading')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/chatgpt/GptQuota.vue